// setProfileInfoDraft.js
'use strict';
import { MERGE_OPERATION_DATA, REMOVE_OPERATION_DATA } from '../ActionTypes.js';

/**
 * Set profile Info Drafts
 * @kind action
 * @param {string} {type} - set Draft type (init | update | clean).
 * @param {string} {field} - if type is update, can specify a specific field.
 * @param {any} {value} - the value of field.
 * @return {Promise} Action promise.
 */

const setProfileInfoDraft =
  ({ type = 'clean', field, selectPath = ['myProfileInfoDraft'], value }) =>
  async dispatch => {
    if (type === 'update') {
      return dispatch({
        type: MERGE_OPERATION_DATA,
        payload: {
          selectPath,
          data: {
            [`${field}:isChanged`]: true,
            [`${field}`]: value,
          },
        },
      });
    } else {
      return dispatch({
        type: REMOVE_OPERATION_DATA,
        payload: {
          selectPath,
        },
      });
    }
  };

export default setProfileInfoDraft;
